import { z } from 'zod';
import { uuid } from './posting.js';
/**
 * Die Antwortverträge der Benutzerverwaltung — `V-vertrag3` (2026-08-29).
 *
 * `apps/api/src/users/users.service.ts` führte `UserSummary`/`CreatedUser`
 * bislang als eigene Formen; der OpenAPI-Erzeuger blieb an `GET /api/v1/users`
 * und `POST /api/v1/users` deshalb `[UNGEKLÄRT]`.
 */
/** Die vier Rollen — `apps/api/src/auth/capabilities.ts`, `APP_ROLES`. */
export const appRoleSchema = z.enum(['admin', 'accountant', 'reviewer', 'readonly']);
/** Ein Benutzer, wie ihn die Liste zeigt — `GET /api/v1/users`. */
export const userSummarySchema = z
    .object({
    id: uuid,
    email: z.string(),
    displayName: z.string(),
    status: z.enum(['active', 'disabled']),
    roles: z.array(appRoleSchema),
    mustChangePassword: z.boolean(),
    totpConfirmed: z.boolean(),
    /** Zeitpunkt, bis zu dem das Konto gesperrt ist — oder `null`. */
    lockedUntil: z.string().nullable(),
})
    .strict();
/**
 * Die Antworthülle von `GET /api/v1/users` — `{ users: [...] }`. Der Umschlag lebt neben seinem
 * Elementschema, damit Server und Oberfläche dieselbe Hülle prüfen (Handbuch §3.969).
 */
export const userListResponseSchema = z.object({ users: z.array(userSummarySchema).readonly() }).strict();
/**
 * Das Ergebnis von `POST /api/v1/users`. Das Einmalpasswort erscheint genau
 * hier und nie wieder.
 */
export const createdUserSchema = z
    .object({
    id: uuid,
    email: z.string(),
    displayName: z.string(),
    roles: z.array(appRoleSchema).readonly(),
    /**
     * Das Einmalpasswort im Klartext. Es steht **nur** in dieser Antwort;
     * gespeichert wird ausschliesslich der Hash, und `must_change_password`
     * ist gesetzt — der neue Benutzer durchläuft damit dieselbe
     * Zustandskette wie der Bootstrap-Administrator.
     */
    oneTimePassword: z.string(),
})
    .strict();
/**
 * Das Ergebnis von `POST /api/v1/users/:id/password/reset` — `W-passwortneu`.
 *
 * Dieselbe Zusage wie bei `createdUserSchema`: Das Einmalpasswort erscheint
 * genau in dieser Antwort und nie wieder. Ohne `roles`, weil sich an den Rollen
 * des Kontos nichts ändert; der Anzeigename und die Adresse stehen dabei, damit
 * die Oberfläche ohne zweite Abfrage sagen kann, für wen das Passwort gilt.
 */
export const passwordResetSchema = z
    .object({
    id: uuid,
    email: z.string(),
    displayName: z.string(),
    /**
     * Das neue Einmalpasswort im Klartext. Gespeichert wird ausschliesslich der
     * Hash; `must_change_password` ist gesetzt, der zweite Faktor bleibt.
     */
    oneTimePassword: z.string(),
})
    .strict();
//# sourceMappingURL=users.js.map